import { render, staticRenderFns } from "./DnsTable.vue?vue&type=template&id=593d3cf3&scoped=true"
import script from "./DnsTable.vue?vue&type=script&lang=js"
export * from "./DnsTable.vue?vue&type=script&lang=js"
import style0 from "./DnsTable.vue?vue&type=style&index=0&id=593d3cf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d3cf3",
  null
  
)

export default component.exports